import { IDeepCopy } from '@common/interfaces/i-deep-copy';

import { ViewStateDef } from './viewstate-def';

export class ViewStateSequence implements IDeepCopy<ViewStateSequence> {
    public viewstates: Array<ViewStateDef> = [];

    private onChange: (value: any) => any;
    public set OnChange(f: (v: any) => any) {
        this.onChange = f;
        for (const vs of this.viewstates) {
            vs.OnChange = v => {
                this.onChange(v);
            };
        }
    }

    public push(vs: ViewStateDef) {
        this.viewstates.push(vs);
        if (this.OnChange) {
            vs.OnChange = v => {
                this.OnChange(v);
            };
        }
    }

    public toJSON() {
        const json: Array<string> = [];
        for (const vs of this.viewstates) {
            if (vs.Selected) json.push(vs.Guid);
        }
        return JSON.stringify(json);
    }

    public deepCopy(): ViewStateSequence {
        const ret = new ViewStateSequence();
        for (const vs of this.viewstates) {
            ret.push(vs.deepCopy());
        }
        return ret;
    }

    public get Valid(): boolean {
        for (const vs of this.viewstates) {
            if (vs.Selected) return true;
        }
        return false;
    }
}
